import { Injectable, inject, signal } from '@angular/core';

import { CashierService } from '@frontend/vanilla/core';

import { ChannelType } from '../config/appConstants';
import { QDInstrument } from '../model/qdInstrument.model';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root',
})
export class OptionListService {
    private dataService = inject(DataService);
    depositAvailable = signal<boolean>(false);
    isDataLoading = signal<boolean>(false);
    _depositAvailable = false;
    _reversalExists = false;
    _selectedOption: QDInstrument;
    _optionList: QDInstrument[];
    _reversalArr: any[];
    _showWithdrawal = false;
    sessionInfo: { [key: string]: string };

    constructor(private cashierService: CashierService) {}
    set showWithdrawal(_showWithdrawal) {
        this._showWithdrawal = _showWithdrawal;
    }

    get showWithdrawal() {
        return this._showWithdrawal;
    }

    set optionList(_optionList) {
        this._optionList = _optionList;
    }

    get optionList() {
        return this._optionList;
    }

    set selectedOption(_selectedOption) {
        this._selectedOption = _selectedOption;
    }

    get selectedOption() {
        return this._selectedOption;
    }

    set reversalExists(_reversalExists) {
        this._reversalExists = _reversalExists;
    }

    get reversalExists() {
        return this._reversalExists;
    }

    set reversalArr(_reversalArr: any[]) {
        this._reversalArr = _reversalArr;
    }

    get reversalArr() {
        return this._reversalArr;
    }

    redirectToMainCashier(_module: string = '&type=options') {
        if ([ChannelType.VC, ChannelType.FC, ChannelType.MC].includes(this.dataService.sessionInfo['channelId'])) {
            parent.postMessage('action=close&showAllOptions=true', '*');
        } else {
            this.cashierService.goToCashier({ skipQuickDeposit: true });
        }
        this.depositAvailable.set(false);
    }
}
